import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  GET_BOARDING_CERTIFICATE_RESULT_STORE_NAME,
  GetBoardingCertificateResultState,
} from './get-boarding-certificate-result.state';

/** Select GetBoardingCertificateResult State */
export const selectGetBoardingCertificateResultState = createFeatureSelector<GetBoardingCertificateResultState>(
  GET_BOARDING_CERTIFICATE_RESULT_STORE_NAME
);

/** Select GetBoardingCertificateResult isPending status */
export const selectGetBoardingCertificateResultIsPendingStatus = createSelector(
  selectGetBoardingCertificateResultState,
  (state) => !!state.isPending
);

/** Select GetBoardingCertificateResult isFailure status */
export const selectGetBoardingCertificateResultIsFailureStatus = createSelector(
  selectGetBoardingCertificateResultState,
  (state) => !!state.isFailure
);
